import { PermissionEnum } from "@/__generated__/graphql";

import { ROLE_PERMISSIONS } from "./Roles.content";

/**
 * What a role allows, as a person reads it: "View only", "Everything", or
 * what it adds to viewing - "View, book payments, reconcile".
 */
export function describePermissions(permissions: PermissionEnum[]): string {
  const allowed = ROLE_PERMISSIONS.filter(({ permission }) =>
    permissions.includes(permission),
  ).map(({ label }) => label.toLowerCase());
  if (allowed.length === 0) return "View only";
  if (allowed.length === ROLE_PERMISSIONS.length) return "Everything";
  return `View, ${allowed.join(", ")}`;
}
